import { drawDiamond, drawEllipse, drawRectangle, drawStar, drawTriangle } from 'rise-ui/utils/canvas/shapes.js';

export const shapeSquishRatio = 0.6;
export const shapeSquishStart = (1 - shapeSquishRatio) / 2;

export function drawNodeSquare(context, x, y, size, stroke = true, fill = true) {
  const radius = size / 2;
  drawRectangle(context, x - radius, y - radius, size, size, stroke, fill);
}

export function drawNodeRectangle(context, x, y, size, stroke = true, fill = true) {
  const radius = size / 2;
  drawRectangle(context, x - radius, y - radius * shapeSquishRatio, size, size * shapeSquishRatio, stroke, fill);
}

export function drawNodeRectangleVertical(context, x, y, size, stroke = true, fill = true) {
  const radius = size / 2;
  drawRectangle(context, x - radius * shapeSquishRatio, y - radius, size * shapeSquishRatio, size, stroke, fill);
}

export function drawNodeCircle(context, x, y, size, stroke = true, fill = true) {
  const radius = size / 2;
  drawEllipse(context, x - radius, y - radius, size, size, stroke, fill);
}

export function drawNodeEllipse(context, x, y, size, stroke = true, fill = true) {
  const radius = size / 2;
  drawEllipse(context, x - radius, y - radius * shapeSquishRatio, size, size * shapeSquishRatio, stroke, fill);
}

export function drawNodeEllipseVertical(context, x, y, size, stroke = true, fill = true) {
  const radius = size / 2;
  drawEllipse(context, x - radius * shapeSquishRatio, y - radius, size * shapeSquishRatio, size, stroke, fill);
}

export function drawNodeTriangle(context, x, y, size, stroke = true, fill = true) {
  const radius = size / 2; x -= radius; y -= radius;
  drawTriangle(context, x + size / 2, y, x + size, y + size, x, y + size, stroke, fill);
}

export function drawNodeTriangleRight(context, x, y, size, stroke = true, fill = true) {
  const radius = size / 2; x -= radius; y -= radius;
  drawTriangle(context, x, y, x + size, y + size / 2, x, y + size, stroke, fill);
}

export function drawNodeTriangleDown(context, x, y, size, stroke = true, fill = true) {
  const radius = size / 2; x -= radius; y -= radius;
  drawTriangle(context, x, y, x + size, y, x + size / 2, y + size, stroke, fill);
}

export function drawNodeTriangleLeft(context, x, y, size, stroke = true, fill = true) {
  const radius = size / 2; x -= radius; y -= radius;
  drawTriangle(context, x, y + size / 2, x + size, y, x + size, y + size, stroke, fill);
}

export function drawNodeDiamond(context, x, y, size, stroke = true, fill = true) {
  const radius = size / 2;
  drawDiamond(context, x - radius, y - radius, size, size, stroke, fill)
}

export function drawNodeStar(context, x, y, size, stroke = true, fill = true) {
  const radius = size * .7;
  drawStar(context, x, y, 5, radius, radius * .4, stroke, fill);
}

export function drawNodeDiamondStar(context, x, y, size, stroke = true, fill = true) {
  const radius = size * .7;
  drawStar(context, x, y, 4, radius, radius * .4, stroke, fill);
}

export function drawNodeBadgeStar(context, x, y, size, stroke = true, fill = true) {
  const radius = size * .7;
  drawStar(context, x, y, 8, radius, radius * .4, stroke, fill);
}

export const NODE_SHAPES = [
  drawNodeCircle,          drawNodeSquare,            drawNodeTriangle,
  drawNodeEllipse,         drawNodeRectangle,         drawNodeTriangleDown,
  drawNodeEllipseVertical, drawNodeRectangleVertical, drawNodeTriangleLeft,
  drawNodeStar,            drawNodeDiamond,           drawNodeTriangleRight,
  drawNodeDiamondStar,     drawNodeBadgeStar,
];

export function getShapeByIndex(index) {
  return NODE_SHAPES[Math.max(0, index || 0) % NODE_SHAPES.length];
}
